import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectUser, updateUserProfile } from "../../store/authSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AccountSettings.css";
import { formatPrice } from "../../utils/helpers";
import { IMAGE_URL1 } from "../../utils/apiURL";

const DEFAULT_AVATAR = "/7.png"; // Image par défaut

const AccountSettings = () => {
  const notifySuccess = (message) =>
    toast.success(message, { className: "toast-container" });
  const notifyError = (message) =>
    toast.error(message, { className: "toast-container" });

  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  // États locaux pour les champs du formulaire
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [username, setUsername] = useState("");
  const [avatar, setAvatar] = useState(null); // L'avatar téléchargé
  const [loading, setLoading] = useState(false); // Loader

  useEffect(() => {
    if (user) {
      setFirstname(user.firstname || "");
      setLastname(user.lastname || "");
      setEmail(user.email || "");
      setMobile(user.mobile || "");
      setUsername(user.username || "");
    }
  }, [user]);

  const handleSaveChanges = async (e) => {
    e.preventDefault();
    setLoading(true);

    const profileData = {
      firstname,
      lastname,
      email,
      mobile,
      username,
      avatar, // Utilisation de l'avatar téléchargé
    };

    try {
      const response = await dispatch(
        updateUserProfile({ profileData })
      ).unwrap();

      // Mettez à jour les champs avec les nouvelles données
      setFirstname(response.user.firstname);
      setLastname(response.user.lastname);
      setEmail(response.user.email);
      setMobile(response.user.mobile);
      setUsername(response.user.username);

      notifySuccess(response.message); // Affiche le message de succès du backend
    } catch (error) {
      notifyError(error.message); // Affiche le message d'erreur du backend
    } finally {
      setLoading(false);
    }
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAvatar(URL.createObjectURL(file)); // Affiche l'aperçu de l'image
    }
  };

  return (
    <div className="accountsettings">
      <h1 className="mainhead1">Personal Information</h1>

      <div className="avatar-upload">
        <div className="avatar-preview">
          {avatar ? (
            <img
              src={avatar}
              alt="Aperçu de l'avatar"
              className="avatar-image"
            />
          ) : (
            <div className="default-avatar">No pictures</div>
          )}
        </div>

        <label htmlFor="avatar-upload" className="upload-button">
          UPLOAD AN IMAGE
        </label>
        <input
          type="file"
          id="avatar-upload"
          accept="image/jpeg, image/jpg, image/png"
          onChange={handleAvatarChange}
          style={{ display: "none" }}
        />
      </div>

      <form onSubmit={handleSaveChanges} className="form">
        <div className="form-group">
          <label htmlFor="firstname">
            First Name <span>*</span>
          </label>
          <input
            type="text"
            id="firstname"
            placeholder={user?.firstname || "First Name"} // "First Name" comme valeur par défaut
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="lastname">
            Last Name <span>*</span>
          </label>
          <input
            type="text"
            id="lastname"
            placeholder={user?.lastname || "Last Name"} // "Last Name" comme valeur par défaut
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">
            Email <span>*</span>
          </label>
          <input
            type="email"
            id="email"
            placeholder={user?.email || "Email"} // "Email" comme valeur par défaut
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="mobile">
            Phone/Mobile <span>*</span>
          </label>
          <input
            type="text"
            id="mobile"
            placeholder={user?.mobile || "Phone/Mobile"} // "Phone/Mobile" comme valeur par défaut
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="username">
            Username <span>*</span>
          </label>
          <input
            type="text"
            id="username"
            placeholder={user?.username || "Username"} // "Username" comme valeur par défaut
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="status">
            Statut <span>*</span>
          </label>
          <input
            type="text"
            id="status"
            placeholder={
              user?.status === 1 ? "Active" : "Deactivated" || "Status"
            }
            readOnly // Désactive l'édition
          />
        </div>

        <div className="form-group">
          <label htmlFor="salary">
            Salary <span>*</span>
          </label>
          <input
            type="text"
            id="salary"
            placeholder={user?.net_salary || user?.net_salary === 0 ? formatPrice(user.net_salary) : "Net Salary"}
            readOnly // Désactive l'édition
          />
        </div>

        <div className="form-group">
          <label htmlFor="salary">
            National Id <span>*</span>
          </label>
          <input
            type="text"
            id="salary"
            placeholder={user?.national_id || "Net Salary"}
            readOnly // Désactive l'édition
          />
        </div>

        <button type="submit" className="mainbutton1" disabled={loading}>
          {loading ? "Saving..." : "Save Changes"}
        </button>
      </form>

      <ToastContainer />
    </div>
  );
};

export default AccountSettings;
